import { vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../../public/icons/reportbook/promote_green.svg'
import _imports_1 from '../../../../public/icons/reportbook/parameter.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-88c011ec"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"width":"100%"} }
const _hoisted_2 = { class: "editorContent" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = ["value"]
const _hoisted_6 = {
  key: 5,
  class: "wbtn-array"
}
const _hoisted_7 = ["disabled"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "accent-svg",
  src: _imports_1
}, null, -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "modalTitle" }
const _hoisted_14 = { class: "modalContent" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "modalTitle" }, "Pick a report book parameter", -1))
const _hoisted_16 = {
  key: 0,
  class: "modalContent"
}
const _hoisted_17 = {
  key: 1,
  class: "modalContent"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = { class: "modalItem" }
const _hoisted_20 = { class: "label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TreeParameterNode = _resolveComponent("TreeParameterNode")!
  const _component_CommonButton = _resolveComponent("CommonButton")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_Empty = _resolveComponent("Empty")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.param.style == 'Input')
        ? _withDirectives((_openBlock(), _createElementBlock("input", {
            key: 0,
            type: "text",
            class: _normalizeClass({interpolation: true}),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.CurrentValue.name) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.ParameterText_Change($event)))
          }, null, 544)), [
            [_vModelText, _ctx.CurrentValue.name]
          ])
        : (_ctx.param.style == 'Date' && (_ctx.FormatDate(_ctx.CurrentValue.key)==null || !_ctx.FormatDate(_ctx.CurrentValue.key).startsWith('{')))
          ? (_openBlock(), _createElementBlock("input", {
              key: 1,
              type: "date",
              class: _normalizeClass({interpolation: false}),
              value: _ctx.FormatDate(_ctx.CurrentValue.key),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ParameterDate_Change($event)))
            }, null, 40, _hoisted_3))
          : (_ctx.param.style == 'Date')
            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                key: 2,
                type: "text",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.CurrentValue.name) = $event)),
                onChange: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ParameterText_Change($event)))
              }, null, 544)), [
                [_vModelText, _ctx.CurrentValue.name]
              ])
            : (_ctx.param.style == 'Tree')
              ? _withDirectives((_openBlock(), _createElementBlock("input", {
                  key: 3,
                  type: "text",
                  style: {"cursor":"pointer"},
                  onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => {_ctx.SelectedTreeParameterValue = null; _ctx.TreeParameterModal = true}, ["stop"])),
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.CurrentValueLabel) = $event)),
                  readonly: ""
                }, null, 512)), [
                  [_vModelText, _ctx.CurrentValueLabel]
                ])
              : (_ctx.param.style == 'List')
                ? _withDirectives((_openBlock(), _createElementBlock("select", {
                    key: 4,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.CurrentValue) = $event))
                  }, [
                    (_ctx.IsUsingAReportBookParameter)
                      ? (_openBlock(), _createElementBlock("option", {
                          key: 0,
                          value: _ctx.CurrentValue
                        }, _toDisplayString(_ctx.CurrentValueLabel), 9, _hoisted_4))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.param.values, (choice, k) => {
                      return (_openBlock(), _createElementBlock("option", { value: choice }, _toDisplayString(_ctx.ValueLabel(choice)), 9, _hoisted_5))
                    }), 256))
                  ], 512)), [
                    [_vModelSelect, _ctx.CurrentValue]
                  ])
                : _createCommentVNode("", true),
      (_ctx.ShowButtonArray)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", {
              class: "wbtn",
              style: {"padding":"5px"},
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.PromoteParameter())),
              disabled: _ctx.IsReportBookParameter || null
            }, _hoisted_9, 8, _hoisted_7),
            _createElementVNode("div", {
              class: "wbtn",
              style: {"padding":"5px"},
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.ReportBookParameterModal = true)),
              disabled: _ctx.IsReportBookParameter || null
            }, _hoisted_12, 8, _hoisted_10)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.TreeParameterModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 0,
          onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.TreeParameterModal = false))
        }, {
          header: _withCtx(() => [
            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.param.label), 1)
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_TransitionGroup, {
                name: "fso",
                tag: "span"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.RootNodes, (node, i) => {
                    return (_openBlock(), _createBlock(_component_TreeParameterNode, {
                      key: _ctx.key(i),
                      Definition: node
                    }, null, 8, ["Definition"]))
                  }), 128))
                ]),
                _: 1
              })
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.TreeParameterModal = false))
            }, null, 8, ["type", "text"]),
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Primary,
              disabled: !_ctx.CanChooseTreeParameterValue,
              text: _ctx.Localizer.Localize('Ok_PascalCase'),
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.ChooseTreeParameterValue()))
            }, null, 8, ["type", "disabled", "text"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.ReportBookParameterModal)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onClose: _ctx.CancelPickReportBookParameter
        }, {
          header: _withCtx(() => [
            _hoisted_15
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", null, [
              (_ctx.ReportBookParameters === null || _ctx.ReportBookParameters.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_Empty, null, {
                      default: _withCtx(() => [
                        _createTextVNode("No report book parameters")
                      ]),
                      _: 1
                    })
                  ]))
                : (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_TransitionGroup, {
                      name: "fso",
                      tag: "span"
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ReportBookParameters, (param, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: _normalizeClass(["modalItemWrapper", {even: i%2==0}]),
                            key: _ctx.key(i),
                            onClick: ($event: any) => (_ctx.SelectReportBookParameter(param)),
                            style: _normalizeStyle({'--i':i/_ctx.ReportBookParameters.length})
                          }, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("span", _hoisted_20, _toDisplayString(param.bookParameter.label), 1)
                            ])
                          ], 14, _hoisted_18))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ]))
            ])
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_CommonButton, {
              type: _ctx.ButtonType.Default,
              text: _ctx.Localizer.Localize('Cancel_PascalCase'),
              onClick: _ctx.CancelPickReportBookParameter
            }, null, 8, ["type", "text", "onClick"])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ]))
}